module.exports = __webpack_public_path__ + "img/logo-b.8cb17988.png";